import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css

// 预览word excle文档 也可预览PDF但是没有使用pdf
import VueOfficeDocx from '@vue-office/docx'
import '@vue-office/docx/lib/index.css'
import VueOfficeExcel from '@vue-office/excel'
import '@vue-office/excel/lib/index.css'
// ppt预览
// import VuePpt from 'vue-ppt'
// import VuePpt from 'vue-ppt'


Vue.component('VueOfficeDocx',VueOfficeDocx)
Vue.component('VueOfficeExcel',VueOfficeExcel)
// Vue.component('vuePpt',VuePpt)



import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control

Vue.use(ElementUI, { locale })
Vue.use(VCharts)

// 引入pdf组件
// import pdf from 'vue2-pdf'
// Vue.use('pdf',pdf)

// Vue.component('pdf', pdf)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js